import axios from 'axios'

const URL_PATH = 'api/pedido'

class DotacaoOrcamentariaPedidoApiClient {
	async buscarListagemPaginada(idPedido) {
		return await axios.get(`${URL_PATH}/${idPedido}/dotacoes`)
	}

	async criarDotacao(idPedido, itens) {
		return await axios.post(`${URL_PATH}/${idPedido}/dotacoes`, { itens })
	}

	async editarValorDotacao({ idDotacao, valor }) {
		return await axios.put(`${URL_PATH}/dotacoes/${idDotacao}/valor`, { valor })
	}

	async excluirDotacao(idDotacaoPedido) {
		return await axios.delete(`${URL_PATH}/dotacoes/${idDotacaoPedido}`)
	}
}

export default new DotacaoOrcamentariaPedidoApiClient()
